import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CalculationStore } from '../../../../../stores/calculation.store';
import { CalculationError } from '../../../../../../../../../../../common/src/errors/calculations/calculation.error';
import {
  calculationErrorMetadata,
} from '../../../../../../../../../../../common/src/metadatas/calculation-error.metadata';
import { TranslateService } from '@ngx-translate/core';
import {
  CalculationResponse,
} from '../../../../../../../../../../../common/dist/angular/responses/calculation.response';
import { RrqOptions } from '../../../../../../../../../../../common/src/options/calculations/rrq/rrq.options';
import {
  RrqResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rrq/results/rrq.result';

@Component({
  selector: 'app-section-84_1-result',
  templateUrl: './rrq-result.component.html',
  styleUrls: ['./rrq-result.component.scss'],
  standalone: false,
})
export class RrqResultComponent implements OnInit, OnDestroy {
  public calculationId: string;

  public calculationResponse: CalculationResponse;
  public options: RrqOptions;
  public results: RrqResult;
  isSectionResponsesCollapsed: boolean = false;
  isSectionResultsCollapsed: boolean = false;
  selectedBadge: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);
  private calculationResponseSubscription: Subscription;

  constructor(private readonly calculationStore: CalculationStore,
              private readonly translateService: TranslateService,
              private readonly activatedRoute: ActivatedRoute) {

    // Start by setting the calculationId
    this.calculationId = this.activatedRoute.snapshot.params.calculationId;

  }

  ngOnInit(): void {

    this.activatedRoute.parent.params.subscribe(params => {
      if (params.calculationId === undefined) {
        return;
      }

      this.calculationId = params.calculationId;

      // Unsubscribe all the subscriptions on route change.
      this.unsubscribeAll();

      this.calculationResponseSubscription = this.calculationStore.get(params.calculationId).subscribe((calculationResponse) => {
        // todo: add a mechanism to know if the results are simply loading (when calculationResponse === undefined) or there's an error (the other two conditions)
        if (calculationResponse === undefined || calculationResponse.options === undefined || calculationResponse.results === undefined) {
          return;
        }

        this.calculationResponse = calculationResponse;
        this.options = calculationResponse.options.options as RrqOptions;
        this.results = calculationResponse.results.results as RrqResult;
      });
    });
  }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  getErrorText(error: string | CalculationError) {
    if (typeof error === 'string') {
      return error;
    }

    if (error.hasOwnProperty('calculationErrorKeyname')) {
      const calculationError = calculationErrorMetadata[error.calculationErrorKeyname];

      if (calculationError === undefined) {
        return 'Erreur inconnue'; // todo: translate this.
      }

      if (calculationError.i18n.hasOwnProperty(this.translateService.currentLang)) {
        return calculationError.i18n[this.translateService.currentLang];
      }

      return calculationError.i18n.fr;
    }
  }

  private unsubscribeAll() {
    this.calculationResponseSubscription?.unsubscribe();
  }
}
